import React from 'react'
import cx from 'classnames'
import styles from './NoTaskList.sass'

export default function NoTaskList() {
  return (
    <div className={cx(styles.root)} data-test="no-task-list">
      <p className={styles.description}>You have no outstanding tasks.</p>
    </div>
  )
}
